/**
 * Thin wrapper around gtag() so pages can fire named events without knowing
 * about window globals. Safe to call before gtag has loaded — pushes to
 * dataLayer through the stub set in index.html.
 */

const GA_ID = process.env.REACT_APP_GA_ID;

export function trackPageView(path, title) {
  if (typeof window === "undefined" || !GA_ID) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: window.location.origin + path,
    page_path: path,
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || !GA_ID) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}
